/** In-match terraforming tutorial milestone events */
export enum TerraformingMilestone {
  None = 0,
  FirstSeedEmpty = 1,
  FirstRefill = 2,
  GrassSeedCount10 = 3,
  FirstSeedBurstPadSeen = 4,
  FirstInvalidFlowerTile = 5
}
